import CustomBreadCrumb from '../../../constants/CustomBreadCrumb'
import CustomCard from '../../../constants/CustomCard'

const ProductionReportsPage = () => {
  const items = [
    {
      title: 'PRODUCTION UPDATE',
      to: '/production-update',
      linkName: 'Production Reports'
    },{
      title: 'PRODUCTION PTD',
      to: '/production-pdt',
      linkName: 'Production Reports'
    },{
      title: 'PROGRESS',
      to: '/production-progress',
      linkName: 'Production Reports'
    },{
      title: 'DRILL STATISTICS',
      to: '/drill-statistic-report',
      linkName: 'DRILL STATISTICS'
    },{
      title: 'EQUIPMENT STATISTICS',
      to: '/equipment-report',
      linkName: 'EQUIPMENT STATISTICS REPORT'
    },{
      title: 'FUEL REPORT',
      to: '/fuel-report',
      linkName: 'Fuel Report'
    },{
      title: 'SAFETY STATISTIC',
      to: '/production-reports',
      linkName: 'Production Reports'
    },{
      title: 'INCIDENT REGISTER',
      to: '/incident-register-report',
      linkName: 'INCIDENT REGISTER REPORT'
    },{
      title: 'ACTIVITY',
      to: '/activity-production',
      linkName: 'ACTIVITY REPORT'
    },

  ]
  return (
    <>
      <CustomBreadCrumb title={'Production Reports'} isReport={false} isDashboard={false} />
      <div className="row mt-5 g-8">
        {
          items.map((item, index) => (
              <div key={index} className='col-xl-3'>
                <CustomCard url={item?.to} title={item?.title} />
              </div>
            )
          )
        }
      </div>
    </>
  );
}
export default ProductionReportsPage;